import { render, staticRenderFns } from "./TipoDeEmprestimo.vue?vue&type=template&id=7cca16eb&scoped=true&lang=pug&"
import script from "./TipoDeEmprestimo.vue?vue&type=script&lang=js&"
export * from "./TipoDeEmprestimo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cca16eb",
  null
  
)

export default component.exports